const createRemoteConfigReport = ({ remoteConfigStatusAtom, }) => ({
    namespace: 'remoteConfig',
    export: async () => remoteConfigStatusAtom.get(),
});
const remoteConfigReportDefinition = {
    id: 'remoteConfigReport',
    type: 'report',
    factory: createRemoteConfigReport,
    dependencies: ['remoteConfigStatusAtom'],
    public: true,
};
export default remoteConfigReportDefinition;
